/**
 * Liste einer Ansicht (Board „Verlauf“): Spalten mit Auswahl, unter 768 px und in schmaler Liste Karten.
 * Darunter „n geladen · Weitere 50 laden“; scheitert das Nachladen, bleiben die Zeilen stehen.
 */
import type { DynamicPricingHistoryView } from '@/shared/api';
import { Button } from '@/shared/components';
import { useContainerQuery } from '@/shared/hooks/useContainerQuery';
import { HistoryCards } from './HistoryCards';
import { HISTORY_NOUN, type HistoryRow } from './historyRows';
import { HistoryTable } from './HistoryTable';

interface Props {
  view: DynamicPricingHistoryView;
  rows: HistoryRow[];
  selectedId?: string;
  mobile: boolean;
  hasMore: boolean;
  loadingMore: boolean;
  /** Warum das Nachladen nicht weiterkam (Fehler mit Grund oder keine Verbindung). */
  loadMoreProblem: string | null;
  onSelect: (id: string) => void;
  onLoadMore: () => void;
}

export function HistoryList(props: Props) {
  const { view, rows, mobile } = props;
  const [one, many] = HISTORY_NOUN[view];
  // Neben der Detailspalte wird die Liste schmal; dann Karten statt abgeschnittener Spalten.
  const { ref, matches: wide } = useContainerQuery(720);
  const cards = mobile || !wide;
  return (
    <div ref={ref} className="flex min-w-0 flex-col">
      {cards ? (
        <HistoryCards
          rows={rows}
          selectedId={mobile ? undefined : props.selectedId}
          onSelect={props.onSelect}
        />
      ) : (
        <HistoryTable
          view={view}
          rows={rows}
          selectedId={props.selectedId}
          onSelect={props.onSelect}
        />
      )}
      <div className="border-paper flex flex-wrap items-center gap-2.5 border-t px-[18px] py-3">
        <span className="text-ink-soft grow text-xs">
          {rows.length} {rows.length === 1 ? one : many} geladen
        </span>
        {props.loadMoreProblem && (
          <span role="alert" className="text-sealwax text-xs">
            {props.loadMoreProblem}
          </span>
        )}
        {props.hasMore && (
          <Button
            variant="secondary"
            className="min-h-11 md:min-h-[38px]"
            loading={props.loadingMore}
            onClick={props.onLoadMore}
          >
            {props.loadMoreProblem ? 'Erneut versuchen' : 'Weitere 50 laden'}
          </Button>
        )}
      </div>
    </div>
  );
}
